import { h } from 'preact'
import cls from 'classnames'

import classes from './rating.scss'
import { useContext } from 'preact/hooks'
import FieldsContext from 'components/business/SurveyForm/Fields/fieldsContext'

interface Props {
  value: number | null
  items: { children: string | JSX.Element; value: number }[]
  onClick: (value: number) => void
  hoverEnable?: boolean
}

const Rating = (props: Props) => {
  const { isMultipleFields } = useContext(FieldsContext)!
  const { value, items, onClick, hoverEnable = true } = props
  const selectIndex = items.findIndex((item) => item.value === value)
  const hasItemSelected = selectIndex > -1

  return (
    <div
      className={cls(classes.ratingRoot, {
        'pointer-events-none': !isMultipleFields && hasItemSelected,
      })}
    >
      {items.map((item, index) => {
        return (
          <div
            key={index}
            className={cls(
              classes.item,
              hoverEnable && classes.webOption,
              index === selectIndex && classes.active,
              index <= selectIndex && 'pulse'
            )}
            onClick={() => {
              if (isMultipleFields || !hasItemSelected) {
                onClick(item.value)
              }
            }}
          >
            <a>{item.children}</a>
          </div>
        )
      })}
    </div>
  )
}

export default Rating
